import cx from 'classnames'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { Card } from '@commutifi-fe/ui'

import { screenSizes } from 'constants/global'
import styles from './styles.module.scss'

export function SurveyLandingPageCardLayout({
  children,
  style
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) {
  const isXSmall = useMediaQuery({ maxWidth: screenSizes.xsMaxWidth })

  return (
    <Card
      bordered={false}
      style={{
        marginTop: '60px',
        minHeight: '250px',
        width: '100%',
        ...(isXSmall && { borderRadius: '18px' }),
        ...style
      }}
      className={cx(!isXSmall && 'u-elevation-1')}
    >
      {isXSmall ? (
        <div className="u-flex-justify-center">
          <div className={styles['card-tilt']} />
        </div>
      ) : null}
      <div className="u-padding--medium">{children}</div>
    </Card>
  )
}
